import { ReactElement } from 'react'

import { Segmented } from 'antd'

import { Flex, Icon, Text } from 'components/core'

type SegmentType = 'parent_level' | 'variant_level'

interface SegmentTypeSelectorProps {
    value: SegmentType
    onChange: (value: SegmentType) => void
}

function SegmentTypeSelector({
    value,
    onChange,
}: SegmentTypeSelectorProps): ReactElement {
    return (
        <Segmented
            value={value}
            onChange={onChange}
            options={[
                {
                    label: (
                        <Flex
                            direction="column"
                            style={{ padding: 4 }}
                            alignItems="start"
                        >
                            <Text variant="bodyMain" element="div">
                                Parent-level Segments
                            </Text>
                            <Text variant="bodySm" color="textLight">
                                Segments with parent-level estimates only
                            </Text>
                        </Flex>
                    ),
                    value: 'parent_level',
                },
                {
                    label: (
                        <Flex
                            direction="column"
                            style={{ padding: 4 }}
                            alignItems="start"
                        >
                            <Flex gap={6}>
                                <Icon name="PACKAGE" color="primary400" />
                                <Text variant="bodyMain" element="div">
                                    Variant-level Segments
                                </Text>
                            </Flex>
                            <Text
                                variant="bodySm"
                                color="textLight"
                                style={{ marginLeft: 20 }}
                            >
                                Segments with parent and variant-level estimate
                                data
                            </Text>
                        </Flex>
                    ),
                    value: 'variant_level',
                },
            ]}
        />
    )
}

export default SegmentTypeSelector
